import { createAsyncAction } from 'typesafe-actions';
import { SidesRepullDto } from './administration.dtos';

export const sidesRepullActions = createAsyncAction(
  'SIDES_REPULL_REQUEST',
  'SIDES_REPULL_SUCCESS',
  'SIDES_REPULL_ERROR'
)<SidesRepullDto, string[], string>();
